import { Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import 'slick-carousel';
import "datatables.net";
import "file-saver";
import 'dom-to-image';
import { ApplicationService } from './services/application.service';
import { AvbobConnectData } from './services/interface.service';
import { MessageService } from './services/message.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';

@Component({
  selector: 'app-connect',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  showCallbackButton = true;
  receivedMessage: string = ''; // Property to display the received message
  platformstatus: string = "yes";
  myIframeSource: string = "";

  @ViewChild('myIframe') myIframe!: ElementRef;

  constructor(    
    public applicationService: ApplicationService,
    public data: AvbobConnectData,
    public messageService: MessageService,
    private ngZone: NgZone, // Add NgZone to the constructor
    private renderer: Renderer2
  ) {

  }

  ngOnInit() {    
    // Existing initialization code (if any)
    window.addEventListener('message', (event) => {
      // Ensure the message is from the trusted parent origin
      if (event.origin === 'https://campaigns.xpressinformation.co.za') {
        this.ngZone.run(() => {
          if (event.data == 'callParentFunction') {
            // Open the genyses app here
            this.platformstatus = "no";
            this.applicationService.loadGenesysChat();
          }
          //Added this aditional rendering to make the component bigger as soon as the chatbot opens
          else if (event.data == 'AvaOpen') {
            const divElement = this.myIframe.nativeElement;
            this.renderer.setStyle(divElement, 'width', '450px');
            this.renderer.setStyle(divElement, 'height', '768px');
          }
          //Added this aditional rendering to make the component smaller as soon as the chatbot closes
          //Change the size for this rendering based on the needs for your buttons not to overlap.
          else if (event.data == 'AvaClose') {
            const divElement = this.myIframe.nativeElement;
            this.renderer.setStyle(divElement, 'width', '150px');
            this.renderer.setStyle(divElement, 'height', '150px');
          }
          // Update the component property to display the message
          this.receivedMessage = event.data.content;
        });
      }
    });
    window.addEventListener('webChatClosed', () => {
      this.platformstatus = "yes";
    });
  }

  get user(): any {
    return this.data.UserInfo;
  }

  get env(): string[] {
    let environment = "";
    if (this.applicationService.environment && this.applicationService.environment == "avbob development") {
      environment = "construction zone";
    }
    else if (this.applicationService.environment && this.applicationService.environment == "quality assurance") {
      environment = "quality assurance";
    }
    if (environment) {
      return environment.split('');
    }
    return null;
  }

  get showIdle(): boolean {
    if (this.applicationService.idleState > 1) {
      return true;
    }
  }

  get isOnline(): boolean {
    return window.navigator.onLine;
  }

  continue() {
    this.applicationService.resetIdle();
  }

  get platform(): number {
    return this.applicationService.applicationMode;
  }

  get isKiosk(): boolean {
    return this.applicationService.isKiosk;
  }

  get showCallbackPanel(): boolean {
    let enableCallMe = sessionStorage.getItem("enableCallMe");
    if (enableCallMe && enableCallMe == "yes") {
      return true;
    }
    return false;
  }

  get environment(): string {
    return this.applicationService.environment;
  }

  doCallBack() {
    this.applicationService.updateClientLead();
    this.showCallbackButton = false;
  }

  get settingsLoaded(): boolean {
    return this.applicationService.settingsLoaded;
  }

  public get selfServiceAVAUrl(): string {
    return this.applicationService.selfServiceAVAUrl;
  }

}
